import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PanicBanner from "@/components/PanicBanner";
import { AssistantWidget } from "@/components/AssistantWidget";
import {
  LayoutDashboard, Radio, PhoneCall, ListChecks, Building2, FileText,
  ShieldAlert, Smartphone, LogOut, UserCog, Fingerprint, GraduationCap,
  MessageSquareLock, BookUser, Crosshair, PhoneOutgoing, ArrowRightLeft, ClipboardList, Scale, LifeBuoy, Ban,
  History, PlugZap, Cctv, Activity, ClipboardCheck, AlertTriangle, Repeat, Landmark, Link2,
  Boxes, BookMarked, HeartPulse, Newspaper, Command, ShieldCheck, Menu, X,
} from "lucide-react";
import client from "@/lib/api";

const NAV = [
  { to: "/", label: "Command Center", icon: LayoutDashboard, testid: "nav-dashboard", group: "OPERATIONS" },
  { to: "/dispatch", label: "Dispatch Board", icon: Radio, testid: "nav-dispatch", group: "OPERATIONS" },
  { to: "/new-call", label: "Call-Taker Console", icon: PhoneCall, testid: "nav-newcall", group: "OPERATIONS" },
  { to: "/call-types", label: "CFS Catalog", icon: ListChecks, testid: "nav-calltypes", group: "OPERATIONS" },
  { to: "/premise", label: "Premise History", icon: Building2, testid: "nav-premise", group: "INTELLIGENCE" },
  { to: "/crime", label: "Crime & Patrol", icon: Crosshair, testid: "nav-crime", group: "INTELLIGENCE" },
  { to: "/ncic", label: "NCIC / CJIS", icon: Fingerprint, testid: "nav-ncic", group: "INTELLIGENCE",
    roles: ["police_dispatcher", "fire_dispatcher", "ems_dispatcher", "call_taker", "field_unit", "pa_state_constable", "supervisor", "watch_commander", "records_supervisor", "admin"] },
  { to: "/rms", label: "Records (RMS)", icon: FileText, testid: "nav-rms", group: "RECORDS & FIELD" },
  { to: "/comms", label: "Secure Comms", icon: MessageSquareLock, testid: "nav-comms", group: "RECORDS & FIELD" },
  { to: "/directory", label: "Agency Directory", icon: BookUser, testid: "nav-directory", group: "RECORDS & FIELD" },
  { to: "/service", label: "Service of Process", icon: Scale, testid: "nav-service", group: "RECORDS & FIELD",
    roles: ["field_unit", "pa_state_constable", "police_dispatcher", "records_supervisor", "supervisor", "watch_commander", "admin"] },
  { to: "/mdt", label: "MDT (Field)", icon: Smartphone, testid: "nav-mdt", group: "RECORDS & FIELD" },
  { to: "/mobile", label: "Mobile Ops", icon: Smartphone, testid: "nav-mobile", group: "RECORDS & FIELD" },
  { to: "/command", label: "Command & Control", icon: Command, testid: "nav-command", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "police_dispatcher", "fire_dispatcher", "ems_dispatcher", "records_supervisor", "admin"] },
  { to: "/security", label: "Security Center", icon: ShieldCheck, testid: "nav-security", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "admin"] },
  { to: "/supervisor", label: "Supervisor", icon: ShieldAlert, testid: "nav-supervisor", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "records_supervisor", "admin"] },
  { to: "/call-audit", label: "8x8 Call Audit", icon: PhoneOutgoing, testid: "nav-call-audit", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "records_supervisor", "police_dispatcher", "fire_dispatcher", "ems_dispatcher", "admin"] },
  { to: "/transfer-log", label: "Transfer Log", icon: ArrowRightLeft, testid: "nav-transfer-log", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "records_supervisor", "admin"] },
  { to: "/comms-daily", label: "Comms Daily Report", icon: ClipboardList, testid: "nav-comms-daily", group: "COMMAND",
    roles: ["police_dispatcher", "fire_dispatcher", "ems_dispatcher", "call_taker", "supervisor", "watch_commander", "records_supervisor", "admin"] },
  { to: "/trainer", label: "Trainer Console", icon: GraduationCap, testid: "nav-trainer", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "records_supervisor", "admin"] },
  { to: "/ia", label: "IA Console", icon: ShieldAlert, testid: "nav-ia", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "records_supervisor", "admin"] },
  { to: "/admin", label: "Administration", icon: UserCog, testid: "nav-admin", group: "COMMAND", roles: ["admin"] },
  { to: "/addons", label: "Add-On Manager", icon: UserCog, testid: "nav-addons", group: "COMMAND", roles: ["admin"] },
  { to: "/assistant", label: "AI Assistant", icon: UserCog, testid: "nav-assistant", group: "OPERATIONS" },
  { to: "/surge", label: "Call Surge", icon: UserCog, testid: "nav-surge", group: "OPERATIONS",
    roles: ["police_dispatcher", "fire_dispatcher", "ems_dispatcher", "call_taker", "supervisor", "watch_commander", "admin"] },
  { to: "/wallboard", label: "Wallboard", icon: UserCog, testid: "nav-wallboard", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "records_supervisor", "admin", "police_dispatcher", "fire_dispatcher", "ems_dispatcher"] },
  { to: "/event-history", label: "Event History", icon: History, testid: "nav-event-history", group: "INTELLIGENCE" },
  { to: "/watch", label: "MATCOM WATCH™", icon: Cctv, testid: "nav-watch", group: "INTELLIGENCE" },
  { to: "/baltimore", label: "Baltimore CFS", icon: Landmark, testid: "nav-baltimore", group: "INTELLIGENCE" },
  { to: "/links", label: "Person/Vehicle Links", icon: Link2, testid: "nav-links", group: "INTELLIGENCE" },
  { to: "/shift-intel", label: "Shift Intelligence", icon: Newspaper, testid: "nav-shift-intel", group: "INTELLIGENCE" },
  { to: "/resources", label: "Resource Status", icon: HeartPulse, testid: "nav-resources", group: "OPERATIONS" },
  { to: "/fleet", label: "Fleet & Equipment", icon: Boxes, testid: "nav-fleet", group: "RECORDS & FIELD" },
  { to: "/policies", label: "Policy / SOP", icon: BookMarked, testid: "nav-policies", group: "RECORDS & FIELD" },
  { to: "/qa", label: "QA Review", icon: ClipboardCheck, testid: "nav-qa", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "records_supervisor", "admin"] },
  { to: "/readiness", label: "Readiness", icon: Activity, testid: "nav-readiness", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "records_supervisor", "police_dispatcher", "fire_dispatcher", "ems_dispatcher", "dispatcher", "admin"] },
  { to: "/repeat-locations", label: "Repeat Locations", icon: Repeat, testid: "nav-repeat-locations", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "records_supervisor", "police_dispatcher", "fire_dispatcher", "ems_dispatcher", "dispatcher", "admin"] },
  { to: "/integrations", label: "Integration Center", icon: PlugZap, testid: "nav-integrations", group: "COMMAND",
    roles: ["supervisor", "watch_commander", "admin"] },
  { to: "/system-status", label: "System Status", icon: Activity, testid: "nav-system-status", group: "COMMAND" },
  { to: "/help", label: "Help Center", icon: LifeBuoy, testid: "nav-help", group: "RECORDS & FIELD" },
  { to: "/exclusions", label: "Exclusion Notices", icon: Ban, testid: "nav-exclusions", group: "RECORDS & FIELD" },
];

const GROUP_ORDER = ["OPERATIONS", "INTELLIGENCE", "RECORDS & FIELD", "COMMAND"];

function initials(name) {
  return (name || "?").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
}

// Degraded-mode alert: polls /system/status every 60s; amber strip when any service is impaired.
function DegradedBanner() {
  const [st, setSt] = useState(null);
  useEffect(() => {
    const check = () => client.get("/system/status").then((r) => setSt(r.data)).catch(() => {});
    check();
    const t = setInterval(check, 60000);
    return () => clearInterval(t);
  }, []);
  if (!st || st.overall === "operational") return null;
  const bad = (st.services || []).filter((s) => s.status !== "operational").map((s) => s.service);
  return (
    <div data-testid="degraded-banner" className="shrink-0 bg-[#F59E0B] text-black font-mono font-bold text-[11px] text-center py-1 flex items-center justify-center gap-2 uppercase">
      <AlertTriangle size={13} /> Degraded Mode — {bad.join(" · ")} impaired. Outbound work is queued for replay (System Status).
    </div>
  );
}

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [now, setNow] = useState(new Date());

  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);

  const doLogout = async () => { await logout(); nav("/login"); };
  const isTraining = user?.env === "training";
  const accent = isTraining ? "#F59E0B" : "#3B82F6";
  const items = NAV.filter((n) => user?.role === "admin" || !n.roles || n.roles.includes(user?.role));
  const [drawer, setDrawer] = useState(false);
  const loc = useLocation();
  useEffect(() => { setDrawer(false); }, [loc.pathname]);

  const sidebar = (
    <>
        <div className="absolute inset-y-0 left-0 w-px bg-gradient-to-b from-transparent via-[#3B82F6]/30 to-transparent" />
        <div className="px-4 py-4 border-b border-[#2C2D35] flex items-center gap-2.5 relative" style={{ paddingTop: "max(1rem, env(safe-area-inset-top))" }}>
          <div className="relative">
            <img src="/agency-logo.jpg" alt="Matcom Office Of Public Safety" className="w-9 h-9 object-contain rounded-sm border border-[#2C2D35]" />
            <span className="live-dot absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-[#22C55E] after:bg-[#22C55E]" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="font-display font-black tracking-tighter text-[13px] leading-none uppercase">Matcom CAD</div>
            <div className="tac-label mt-1 truncate">Multi-Agency PSAP</div>
          </div>
          <button type="button" data-testid="nav-drawer-close" onClick={() => setDrawer(false)} className="lg:hidden p-2 -mr-2 text-[#9CA3AF] hover:text-white"><X size={18} /></button>
        </div>

        <nav className="flex-1 overflow-y-auto py-3 overscroll-contain">
          {GROUP_ORDER.map((g) => {
            const gi = items.filter((n) => n.group === g);
            if (!gi.length) return null;
            return (
              <div key={g} className="mb-1">
                <div className="px-4 pt-2 pb-1 tac-label opacity-70">{g}</div>
                {gi.map((n) => (
                  <NavLink key={n.to} to={n.to} end={n.to === "/"} data-testid={n.testid}
                    className={({ isActive }) =>
                      `group relative flex items-center gap-3 px-4 py-2.5 lg:py-2 text-sm tac-hover ${
                        isActive
                          ? "bg-[#141518] text-white"
                          : "text-[#9CA3AF] hover:text-white hover:bg-[#141518] hover:translate-x-0.5"
                      }`
                    }>
                    {({ isActive }) => (
                      <>
                        <span className={`absolute left-0 top-1 bottom-1 w-[3px] rounded-r ${isActive ? "" : "opacity-0"}`}
                          style={{ background: accent, boxShadow: isActive ? `0 0 8px ${accent}` : "none" }} />
                        <n.icon size={16} strokeWidth={1.75} style={{ color: isActive ? accent : undefined }} />
                        <span className="font-head">{n.label}</span>
                      </>
                    )}
                  </NavLink>
                ))}
              </div>
            );
          })}
        </nav>

        <div className="border-t border-[#2C2D35] p-3" style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}>
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-sm flex items-center justify-center font-display font-black text-xs shrink-0 border"
              style={{ color: accent, borderColor: accent + "66", background: accent + "1A" }}>
              {initials(user?.name)}
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-head font-semibold truncate" data-testid="current-user-name">{user?.name}</div>
              <div className="tac-label truncate">{user?.role?.replace(/_/g, " ")} · {user?.badge}</div>
            </div>
          </div>
          <div className="mt-2 flex items-center justify-between font-mono text-[10px] text-[#6B7280] px-0.5">
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full" style={{ background: accent }} />
              {isTraining ? "TRAINING" : "LIVE"}
            </span>
            <span className="tabular-nums">{now.toLocaleTimeString("en-GB", { hour12: false })}</span>
          </div>
          <button data-testid="logout-btn" onClick={doLogout}
            className="mt-2 w-full flex items-center justify-center gap-2 px-3 py-2 lg:py-1.5 text-xs font-head bg-[#1E1F24] hover:bg-[#2C2D35] border border-[#2C2D35] tac-hover">
            <LogOut size={13} /> Sign Out
          </button>
        </div>
    </>
  );

  return (
    <div className="app-viewport w-screen flex bg-[#0A0A0A] text-[#F9FAFB] overflow-hidden">
      {/* Sidebar — fixed on desktop / iPad landscape; slide-over drawer on iPhone / iPad portrait */}
      <aside className="hidden lg:flex w-60 shrink-0 border-r border-[#2C2D35] bg-[#0d0e11] flex-col relative">{sidebar}</aside>
      {drawer && (
        <div className="lg:hidden fixed inset-0 z-[90]" data-testid="nav-drawer">
          <div className="absolute inset-0 bg-black/70" onClick={() => setDrawer(false)} />
          <aside className="absolute inset-y-0 left-0 w-[82vw] max-w-[300px] border-r border-[#2C2D35] bg-[#0d0e11] flex flex-col shadow-2xl" style={{ animation: "tacFadeUp .18s ease-out" }}>{sidebar}</aside>
        </div>
      )}

      {/* Main */}
      <main className="flex-1 min-w-0 overflow-hidden flex flex-col">
        {/* Mobile top bar */}
        <div className="lg:hidden shrink-0 flex items-center gap-2 px-3 border-b border-[#2C2D35] bg-[#0d0e11]" style={{ paddingTop: "max(0.5rem, env(safe-area-inset-top))", paddingBottom: "0.5rem" }}>
          <button type="button" data-testid="nav-drawer-open" onClick={() => setDrawer(true)} className="p-2 -ml-2 text-[#E5E7EB]" aria-label="Open menu"><Menu size={22} /></button>
          <img src="/agency-logo.jpg" alt="" className="w-7 h-7 object-contain rounded-sm border border-[#2C2D35]" />
          <div className="font-display font-black tracking-tighter text-sm uppercase leading-none">Matcom CAD</div>
          <span className="ml-auto font-mono text-[10px]" style={{ color: accent }}>{isTraining ? "TRAINING" : "LIVE"} · {now.toLocaleTimeString("en-GB", { hour12: false })}</span>
        </div>
        <PanicBanner />
        <DegradedBanner />
        {isTraining && (
          <div data-testid="training-banner" className="shrink-0 relative bg-[#F59E0B] text-black font-display font-black text-xs text-center py-1.5 tracking-wider flex items-center justify-center gap-2 uppercase">
            <span className="absolute inset-y-0 left-0 w-16 tac-stripes opacity-60" />
            <GraduationCap size={14} /> Training Environment — Simulation Only · Not A Live System
            <span className="absolute inset-y-0 right-0 w-16 tac-stripes opacity-60" />
          </div>
        )}
        {children}
      </main>
      <AssistantWidget />
    </div>
  );
}

export function PageHeader({ title, sub, right, seal }) {
  return (
    <div className="shrink-0 px-3 sm:px-6 py-3 sm:py-4 border-b border-[#2C2D35] bg-[#0d0e11] flex flex-wrap items-center justify-between gap-x-4 gap-y-2 relative">
      <div className="absolute bottom-0 left-0 h-px w-40 bg-gradient-to-r from-[#3B82F6] to-transparent" />
      <div className="flex items-center gap-3 min-w-0">
        {seal ? <img src={seal} alt="Division seal" data-testid="page-header-seal" className="w-10 h-10 sm:w-12 sm:h-12 rounded-full shrink-0" /> : <span className="w-1 h-8 bg-[#3B82F6] shrink-0" />}
        <div className="min-w-0">
          <h1 className="font-display font-black tracking-tighter text-xl sm:text-2xl leading-none uppercase truncate">{title}</h1>
          {sub && <p className="tac-label mt-1.5 hidden sm:block">{sub}</p>}
        </div>
      </div>
      {right && <div className="flex items-center gap-2 flex-wrap max-w-full overflow-x-auto no-scrollbar">{right}</div>}
    </div>
  );
}
